/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAccountShow } from '../../axios/whatsAppAccountShow'
import type {
	WhatsAppAccountShowError,
	WhatsAppAccountShowPathParams,
	WhatsAppAccountShowResponse,
} from '../../types/WhatsAppAccountShow'

export const whatsAppAccountShowQueryKey = (organisationId: WhatsAppAccountShowPathParams['organisationId']) =>
	[{ url: '/organisations/:organisationId/whatsapp-account', params: { organisationId } }] as const

export type WhatsAppAccountShowQueryKey = ReturnType<typeof whatsAppAccountShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::show */
export function whatsAppAccountShowQueryOptions(
	organisationId: WhatsAppAccountShowPathParams['organisationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAccountShowResponse,
		AxiosError<WhatsAppAccountShowError>,
		WhatsAppAccountShowResponse,
		WhatsAppAccountShowQueryKey
	>({
		queryKey: whatsAppAccountShowQueryKey(organisationId),
		queryFn: ({ signal }) => whatsAppAccountShow(organisationId, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::show */
export function useWhatsAppAccountShow<TSelectData = WhatsAppAccountShowResponse>(
	organisationId: WhatsAppAccountShowPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAccountShowResponse,
					AxiosError<WhatsAppAccountShowError>,
					TSelectData,
					WhatsAppAccountShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAccountShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAccountShowQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::show */
export function useWhatsAppAccountShowSuspense<TSelectData = WhatsAppAccountShowResponse>(
	organisationId: WhatsAppAccountShowPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAccountShowResponse,
					AxiosError<WhatsAppAccountShowError>,
					TSelectData,
					WhatsAppAccountShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAccountShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAccountShowQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
